<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <div class="text-center">
        <router-link to="/" class="flex items-center justify-center">
          <img 
            src="@/assets/logo/logo_horizntal.png" 
            alt="Ruxzom Logo" 
            class="h-12"
          />
        </router-link>
        <h2 class="mt-6 text-3xl font-heading font-bold text-gray-900">
          Create new password
        </h2>
        <p class="mt-2 text-sm text-gray-600">
          Please enter your new password below.
        </p>
      </div>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form @submit.prevent="handleSubmit" class="space-y-6">
          <div>
            <label for="email" class="form-label">Email address</label>
            <input
              id="email"
              v-model="form.email"
              type="email"
              autocomplete="email"
              required
              readonly
              class="form-input bg-gray-50 cursor-not-allowed"
            />
          </div>

          <div>
            <label for="password" class="form-label">New Password</label>
            <input
              id="password"
              v-model="form.password"
              type="password"
              required
              class="form-input"
              :class="{ 'border-red-300 focus:border-red-500 focus:ring-red-500': errors.password }"
            />
            <p v-if="errors.password" class="mt-1 text-sm text-red-600">{{ errors.password }}</p>
          </div>

          <div>
            <label for="password_confirmation" class="form-label">Confirm New Password</label>
            <input
              id="password_confirmation"
              v-model="form.password_confirmation"
              type="password"
              required
              class="form-input"
            />
          </div>

          <div>
            <button
              type="submit"
              :disabled="uiStore.loading"
              class="w-full btn btn-primary"
            >
              <span v-if="uiStore.loading" class="inline-flex items-center">
                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Updating...
              </span>
              <span v-else>Reset Password</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useUIStore } from '@/stores/ui'

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const uiStore = useUIStore()

const form = reactive({
  token: '',
  email: '',
  password: '',
  password_confirmation: ''
})

const errors = ref({})

onMounted(() => {
  form.token = route.params.token || ''
  form.email = route.query.email || ''

  if (!form.token || !form.email) {
    uiStore.showNotification({
      type: 'error',
      title: 'Invalid Link',
      message: 'The password reset link is invalid or has expired.'
    })
    router.push('/login')
  }
})

const handleSubmit = async () => {
  errors.value = {}

  if (form.password !== form.password_confirmation) {
    errors.value.password = 'Passwords do not match'
    return
  }

  if (form.password.length < 8) {
    errors.value.password = 'Password must be at least 8 characters'
    return
  }

  const result = await authStore.resetPassword(form)
  if (result.success) {
    router.push('/login')
  }
}
</script>
